<p-card>
  <div class="grid">
    <div class="col-6 md:col-6 lg:col-6 breadcrumbrightmenu">
      <button 
        pTooltip="Help" 
        tooltipPosition="left" 
        aria-hidden="true" 
        class="fa fa-question helpicon"
        (click)="helpservice.openhelpmodal(ref, dialogService, 'Help', 1)">
      </button>
    </div>
  </div>

  <div>
    <div class="grid">
      <div class="col-11">
        <h2>Introduction</h2>
        <h3>
          Complinity Compliance is cloud based Governance Risk and Compliance (GRC) software. 
          The software has many modules which are, by itself, full-fledged systems. 
          All the modules are integrated and driven through a single logon and use common masters 
          (like Company, Department, Location etc.). Some examples of the modules are Compliance, 
          Contract Management, Registration, Insurance and Internal Audit.
        </h3>
      </div>
    </div>
  </div>

  <div class="mr-0" *ngIf="listarray.length > 0">
    <p-table 
      #dt 
      [value]="listarray" 
      [autoLayout]="true"
      [rows]="numberofrowsingrid"
      [scrollable]="true" 
      scrollDirection="horizontal" 
      scrollHeight="{{commonScrollHeight}}"
      [globalFilterFields]="['topic','helptext','rid']"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" 
      sortField="createdon"
      [rowsPerPageOptions]="paginatorArray" 
      dataKey="id" 
      [rowHover]="true" 
      [showCurrentPageReport]="true"
      [resizableColumns]="true"
      columnResizeMode="expand"    
      paginatorLocale="fa-IR" 
      [paginator]="listarray.length > 0" 
      [sortOrder]="1" 
      sortField="productinitial" 
      (sortFunction)="customSort($event)" 
      [customSort]="true"
      responsiveLayout="scroll"
      (onPage)="handlePageChange($event)">

      <!-- Search -->
      <ng-template pTemplate="caption">
        <div class="grid">
          <div class="col-3">&nbsp;</div>
          <div class="col-6">
            <span class="p-input-icon-lft">
              <i icon="pi pi-search"></i>
              <input 
                class="form-control tablesearch" 
                pInputText 
                type="text" 
                id="tablesearch"
                (input)="dt.filterGlobal($any($event.target).value , 'contains'); searchTerm = $any($event.target).value;"
                placeholder="Search in User Help"
                pTooltip="Enter Search Criteria" 
                tooltipPosition="top" />
            </span>
          </div>
        </div>
      </ng-template>
      
      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <ng-container *ngFor="let col of _selectedColumns">
            <th 
              [pSortableColumn]="col.field" 
              *ngIf="col.isChecked" 
              pResizableColumn>
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </ng-container>
            <th pResizableColumn>Action </th>
        </tr>
      </ng-template>
    
      <!-- Body -->
      <ng-template pTemplate="body" let-data>
        <tr style="height:3rem;">
          <td 
            style="width: 10% !important; vertical-align: top;"  
            pTooltip="{{data['productinitial']}}"   
            [innerHTML]="highlight(data.productinitial, searchTerm)">
          </td>
          <td  
            style="vertical-align: top; width: 10% !important; white-space: normal !important; word-wrap: break-all !important;" 
            pTooltip="{{data['topic']}}"   
            [innerHTML]="highlight(data.topic, searchTerm)">
          </td>
          <td  
            style="vertical-align: top; width: 70% !important; white-space: normal !important; word-wrap: break-all !important;"   
            [innerHTML]="highlight(data.helptext, searchTerm)">
          </td>
          <td style="width: 10%; vertical-align: top;">
            <p-button 
              class="m-1"  
              label="Visit Page" 
              styleClass="customesave" 
              (click)="goToPage(data.webpage,data.productinitial)">
            </p-button>
          </td>   
        </tr>
      </ng-template>

   <ng-template pTemplate="emptymessage">
    <tr>
      <td *ngIf="listarray.length === 0" class="datanotfound">
        No data available
      </td>
    </tr>
  </ng-template>
    </p-table>
  </div>
</p-card>

